import React from "react";
import { ConfirmationPopupProps } from '../interFaces/interfaces';
import "../css/others/Popup.css";
const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({ message, onConfirm, onCancel, confirmText = "Confirm", cancelText = "Cancel" }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <p>{message}</p>
        <div className="buttons">
          <button onClick={onCancel} className="cancelbutton">{cancelText}</button>
          <button onClick={onConfirm} className="savebutton">{confirmText}</button>
        </div>
      </div>
    </div>
  );
};
export default ConfirmationPopup;